import { CohortCtrl } from './cohort.controller';

export const CohortComponent = {
  controller: CohortCtrl,
  template: require('./cohort.html'),
  bindings: {
    cohort: '<',
    currentSchool: '<',
  },
};
